const CasesList = () => {
  const casesCards = Array.from(document.querySelectorAll('.cases__item'));
  if (!casesCards) return;

  casesCards.forEach((card) => {
    const moreInfoBtns = card.querySelectorAll('.cases__item-more-btn');
    if (!moreInfoBtns) return;
    moreInfoBtns.forEach((moreInfoBtn) => {
      moreInfoBtn.addEventListener('click', (e) => {
        e.preventDefault();
        card.classList.toggle('touch-active');
      });
    });
  });
}

export default CasesList;